import { useMemo } from 'react';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { onErrorDefault } from '@occc-app/dataAccessLayer/utils';
import {
  ScanDataSubmissionType,
  useGetScanDataSubmissionsQuery,
  ScanDataSubmissionsFragment,
} from '@occc/graphql';
import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';

type UseScanDataPastSubmissionDetailsProps = {
  submissionDate: Date;
  type?: ScanDataSubmissionType;
};

export const useScanDataPastSubmissionDetails = ({
  type,
  submissionDate,
}: UseScanDataPastSubmissionDetailsProps) => {
  const submissionDateEquals = useMemo(
    () => formatDateTime(submissionDate, DateTimeFormat.DateDashed),
    [submissionDate],
  );

  const response = useGetScanDataSubmissionsQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    onError: onErrorDefault,
    variables: {
      filter: {
        submissionDateEquals,
      },
    },
  });

  const submission = useMemo((): ScanDataSubmissionsFragment | undefined => {
    if (!response.data?.scanDataSubmissions?.edges) {
      return undefined;
    }

    const submissions = response.data.scanDataSubmissions.edges.map((edge) => edge.node);

    if (type) {
      return submissions.find((s) => s.type === type);
    }

    return submissions[0];
  }, [response.data, type]);

  return {
    ...response,
    submission,
  };
};
